const config = {
    ENDPOINT: '/dangerous-ws', 
    BASE_URL: '/dangerous-goods-web',
    CLIENT_ID: '0oafvcdcbyYEYmYsF4h7',
    OKTA_URL: 'https://login.usps.gov/oauth2/aus59ik9q9ijg0XY94h7/v1/authorize',
    CLIENT_SECRET: 'J1VMAQ3YkvgZYtHGPVXY_GpES5WrlpGVLHffRShVhfxIQI_0_J8VuhphO5i4obts',
    ISSUER: 'https://login.usps.gov/oauth2/aus59ik9q9ijg0XY94h7',
    LOGIN: 'internal'
  }
  
  export default config
  